(function () {
  var POPUP_ID = 'gfs-email-popup';
  var KEY_SUBSCRIBED = 'gfs_popup_subscribed';
  var KEY_DISMISSED = 'gfs_popup_dismissed';
  var COOKIE_NAME = 'gfs_subscribed';
  var DISMISS_DAYS = 7;
  var DELAY_MS = 4000;
  var successShown = false;

  // --- Cookie helpers ---
  function setSubscribedCookie() {
    try {
      var d = new Date();
      d.setFullYear(d.getFullYear() + 1);
      document.cookie = COOKIE_NAME + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  function getSubscribedCookie() {
    try {
      return document.cookie.split(';').some(function (c) {
        return c.trim().indexOf(COOKIE_NAME + '=') === 0;
      });
    } catch (e) { return false; }
  }

  // Mark subscribed in both localStorage AND cookie so either survives
  function markSubscribed() {
    try { localStorage.setItem(KEY_SUBSCRIBED, '1'); } catch (e) {}
    setSubscribedCookie();
  }

  function shouldShow() {
    // Check localStorage
    try {
      if (localStorage.getItem(KEY_SUBSCRIBED)) return false;
    } catch (e) {}
    // Check cookie (covers cases where localStorage was cleared or unavailable)
    if (getSubscribedCookie()) return false;
    // Check dismiss timer
    try {
      var dismissed = localStorage.getItem(KEY_DISMISSED);
      if (dismissed) {
        var age = Date.now() - parseInt(dismissed, 10);
        if (age < DISMISS_DAYS * 24 * 60 * 60 * 1000) return false;
      }
    } catch (e) {}
    return true;
  }

  function showPopup() {
    var el = document.getElementById(POPUP_ID);
    if (!el) return;
    el.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function hidePopup() {
    var el = document.getElementById(POPUP_ID);
    if (!el) return;
    el.style.display = 'none';
    document.body.style.overflow = '';
    try { localStorage.setItem(KEY_DISMISSED, Date.now().toString()); } catch (e) {}
  }

  function showSuccess() {
    successShown = true;
    var formWrap = document.getElementById('gfs-popup-form-wrap');
    var success = document.getElementById('gfs-popup-success');
    if (formWrap) formWrap.style.display = 'none';
    if (success) success.style.display = 'block';
    // Belt-and-suspenders: ensure subscribed is marked here too
    markSubscribed();
  }

  function init() {
    if (!shouldShow()) return;

    var popup = document.getElementById(POPUP_ID);
    if (!popup) return;

    // Close buttons — always work, even after success is shown
    popup.querySelectorAll('.gfs-popup-close').forEach(function (btn) {
      btn.addEventListener('click', hidePopup);
    });

    // Click outside modal — disabled once success/promo code is showing
    popup.addEventListener('click', function (e) {
      if (successShown) return;
      if (e.target === popup) hidePopup();
    });

    // Escape key — disabled once success/promo code is showing
    document.addEventListener('keydown', function (e) {
      if (successShown) return;
      if (e.key === 'Escape') hidePopup();
    });

    // Form submission
    var form = document.getElementById('gfs-popup-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Subscribing...'; }

        // Mark subscribed NOW — before the fetch — so even if the page
        // navigates or reloads before the callback fires, the flag is set
        markSubscribed();

        var data = new FormData(form);

        fetch('/contact', {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) {
          showSuccess();
        }).catch(function () {
          // Network error — still show success (email was likely captured)
          showSuccess();
        });
      });
    }

    setTimeout(showPopup, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
